const GetEncounterOrderChanges = (prevData, newData, changes) => {
    let key = prevData.Entity_Details?.classify?.documentLevel != newData.Entity_Details?.classify?.documentLevel ? prevData.Entity_Details?.classify?.documentLevel : newData.Entity_Details.classify?.documentLevel
    let prevValues = Object.keys(prevData?.Entity_Details?.ehrDetails?.[key?.toLowerCase()] || {});
    let currentValues = Object.keys(newData?.Entity_Details?.ehrDetails?.[newData.Entity_Details.classify?.documentLevel?.toLowerCase()] || {});
    if (JSON.stringify(prevValues) != JSON.stringify(currentValues) || prevData.Entity_Details.classify?.documentLevel != newData.Entity_Details.classify?.documentLevel) {
        changes.push({
            field: "Document Type",
            prevValue: `${prevData.Entity_Details.classify?.documentLevel}${prevValues?.length ? ":" : ""} ${prevValues.join(", ")}`,
            currentValue: `${newData.Entity_Details.classify?.documentLevel}${currentValues?.length ? ":" : ""} ${currentValues.join(", ")}`,
        });
    }
}

const GetExtractionChanges = (prevData, newData, changes) => {
    let keys = {
        "patientName": "Patient Name",
        "dateOfBirth": "Patient Date of Birth",
        "provider_details": "To",
        "address": "Address",
        "phone_number": "Phone Number"
    };
    let prevExt = prevData?.Entity_Details?.extraction || {};
    Object.keys(keys).forEach(key => {
        if (prevExt[key]?.value != newData?.Entity_Details?.extraction[key]?.value) {
            changes.push({
                field: prevExt[key]?.normalized || keys[key],
                prevValue: prevExt[key]?.value || "",
                currentValue: newData?.Entity_Details?.extraction[key]?.value || ""
            });
        }
    });
}

const GetNotificationChanges = (prevData, newData, changes) => {
    if (prevData?.Notifications && newData?.Notifications && Object.keys(prevData?.Notifications)?.length != Object.keys(newData?.Notifications)?.length) {
        changes.push({
            field: "Duplicate Notifications",
            prevValue: prevData?.Notifications?.Duplicate_Document_IDs,
            currentValue: ""
        });
    }

    if (prevData?.Entity_Details?.spam_notification_removed != newData?.Entity_Details?.spam_notification_removed) {
        changes.push({
            field: "Spam Notifications",
            prevValue: "",
            currentValue: "Removed"
        });
    }

    if (prevData?.Entity_Details?.error_notification_removed != newData?.Entity_Details?.error_notification_removed) {
        changes.push({
            field: "Error Notifications",
            prevValue: "",
            currentValue: "Removed"
        });
    }

    if (prevData?.Entity_Details?.is_care_everywhere != newData?.Entity_Details?.is_care_everywhere) {
        changes.push({
            field: "Care Everywhere Notifications",
            prevValue: "",
            currentValue: "Removed"
        });
    }

}

const GetSubCategoryChanges = (prevData, newData, changes) => {
    if (prevData?.Entity_Details?.classify?.documentSubCategory != newData?.Entity_Details?.classify?.documentSubCategory) {
        changes.push({
            field: "Sub Category",
            prevValue: prevData?.Entity_Details?.classify?.documentSubCategory,
            currentValue: newData?.Entity_Details?.classify?.documentSubCategory
        });
    }
}

const GetFlagNoteChanges = (prevData, newData, changes) => {
    if (newData?.Entity_Details?.notes?.length && prevData?.Entity_Details?.notes != newData?.Entity_Details?.notes) {
        changes.push({
            field: "Flag Notes",
            prevValue: prevData?.Entity_Details?.notes || "",
            currentValue: newData?.Entity_Details?.notes || ""
        });
    }
}

const GetFaxRemovalChanges = (prevData, newData, changes) => {
    const prevEnable = prevData?.Entity_Details?.fax_cover_page_drop?.enable;
    const newEnable = newData?.Entity_Details?.fax_cover_page_drop?.enable;

    if (prevEnable != newEnable) {
        changes.push({
            field: "Fax Page Remove",
            prevValue: prevEnable ? "Fax page remove enabled" : "Fax page remove disabled",
            currentValue: newEnable ? "Fax page remove enabled" : "Fax page remove disabled"
        });
    }
}

const GetFlagChanges = (prevData, newData, changes) => {
    let flag = false;
    for (let i = 0; i < prevData.Tags?.length; i++) {
        let prev = prevData.Tags[i];
        for (let j = 0; j < newData.Tags?.length; j++) {
            let next = newData.Tags[j];
            if (prev.tag_display_name == next.tag_display_name && prev.enabled != next.enabled) {
                flag = true;
                break;
            }
        }
        if (flag) break;
    }
    let prevValues = prevData.Tags.reduce((acc, m) => {
        if (m.enabled) acc.push(m.tag_display_name);
        return acc
    }, []);
    let currentValues = newData.Tags.reduce((acc, m) => {
        if (m.enabled) acc.push(m.tag_display_name);
        return acc
    }, []);

    if (flag) {
        changes.push({
            field: "Flags",
            prevValue: prevValues?.join(", ") || "",
            currentValue: currentValues?.join(", ") || ""
        });
    }
}

const GetDocDescriptionChanges = (prevData, newData, changes) => {
    if (newData?.Entity_Details?.doc_description?.length && prevData?.Entity_Details?.doc_description != newData?.Entity_Details?.doc_description) {
        changes.push({
            field: "Document Description",
            prevValue: prevData?.Entity_Details?.doc_description || "",
            currentValue: newData?.Entity_Details?.doc_description || ""
        });
    }
}

const GetPatientMRNChanges = (prevData, newData, changes) => {
    if (newData?.Entity_Details?.patientMatch?.MRN?.length && newData?.Entity_Details?.patientMatch?.MRN != prevData?.Entity_Details?.patientMatch?.MRN) {
        changes.push({
            field: "Patient MRN",
            prevValue: prevData?.Entity_Details?.patientMatch?.MRN || "",
            currentValue: newData?.Entity_Details?.patientMatch?.MRN || ""
        });
    }
}

const GetPDFRotatedChanges = (prevData, newData, changes) => {
    if (newData?.Entity_Details?.rotated_pages) {
        let prev = prevData?.Entity_Details?.rotated_pages, next = newData?.Entity_Details?.rotated_pages
        let values = [];
        for (let i = 1; i <= newData.Page_Count; i++) {
            if (!prev?.[i] && !next?.[i]) continue;
            else if (!prev?.[i] && next?.[i] && next?.[i] != 360) values.push(i);
            else if (prev?.[i] != next?.[i]) values.push(i);
        }

        if (values.length) {
            changes.push({
                field: "PDF Modification - Rotated",
                prevValue: "",
                currentValue: "Modified"
            });
        }
    }
}
const GetDocSplitChanges = (prevData, newData, changes) => {
    if (newData?.Entity_Details?.docSplitData) {
        let prev = prevData?.Entity_Details?.docSplitData, next = newData?.Entity_Details?.docSplitData;
        if (prev?.length != next?.length) {
            changes.push({
                field: "PDF Modification - Document Split",
                prevValue: "",
                currentValue: "Modified"
            });
            return;
        } else {
            let flag = false;
            for (let i = 0; i < next.length - 1; i++) {
                for (let j = 0; j < prev.length - 1; j++) {
                    if (next[i].patient_name != prev[j].patient_name || next[i].dob != prev[j].dob || next[i].start != prev[j].start || next[i].end != prev[j].end || next[i].sub_category != prev[j].sub_category) {
                        changes.push({
                            field: "Document Split",
                            prevValue: "",
                            currentValue: "Modified"
                        });
                        flag = true;
                        break;
                    }
                }
                if (flag) break;
            };
        }
    }
}

const GetFieldChanges = (prevData, newData, action) => {
    let changesMade = [];
    GetExtractionChanges(prevData, newData, changesMade); // track extraction card changes
    if (action == "pm") GetPatientMRNChanges(prevData, newData, changesMade); // track mrn changes changes
    GetDocDescriptionChanges(prevData, newData, changesMade); // track doc description changes
    GetEncounterOrderChanges(prevData, newData, changesMade); // track encounter and order changes
    GetSubCategoryChanges(prevData, newData, changesMade); // track sub category changes
    GetFlagNoteChanges(prevData, newData, changesMade); // track flag note changes
    GetFlagChanges(prevData, newData, changesMade); // track flag selection changes
    GetNotificationChanges(prevData, newData, changesMade); // track notification changes
    GetFaxRemovalChanges(prevData, newData, changesMade); // track fax page removal
    GetDocSplitChanges(prevData, newData, changesMade); // track docSplit changes
    GetPDFRotatedChanges(prevData, newData, changesMade); // track rotation changes

    return changesMade;

}

export default GetFieldChanges;